import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function setExternalTrainingModuleCurrentImport(
   moduleid: number,
   importid: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('put', `/external_training_modules/${moduleid}/current`, {
      ...common,
      body: {
         importid,
      },
   });
}
